import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  total: number | string;
  last24h?: number | string;
  icon?: React.ReactNode;
}

const StatsCard: React.FC<Props> = ({ title, total, last24h, icon }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-slate-50/70 backdrop-blur-sm border-2 border-slate-300 ring-1 ring-slate-200 p-5 rounded-xl shadow-xl flex flex-col gap-3">
      <div className="flex items-center gap-3 text-gray-600">
        {icon}
        <h3 className="font-semibold text-sm text-slate-700">{title}</h3>
      </div>

      <p className="text-4xl font-extrabold text-slate-800">{total}</p>

      {last24h !== undefined && (
        <p className="text-sm text-gray-500">
          <span className="font-medium">{last24h}</span>&nbsp;
          {t('admin.in_last_24h')}
        </p>
      )}
    </div>
  );
};

export default StatsCard;
